const loading = new Map<string, Promise<void>>();

export function loadScript(src: string): Promise<void> {
  const current = loading.get(src);
  if (current) return current;
  const promise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
    if (existing?.dataset.loaded === "true") return resolve();
    const script = existing || document.createElement("script");
    script.src = src;
    script.async = true;
    script.addEventListener("load", () => { script.dataset.loaded = "true"; resolve(); }, { once: true });
    script.addEventListener("error", () => reject(new Error(`Unable to load ${src}`)), { once: true });
    if (!existing) document.head.appendChild(script);
  });
  loading.set(src, promise);
  return promise;
}

